import React from 'react';

const AppleIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" {...props}>
    <path
      d="M13.6286 10.6358C13.6385 9.86923 13.8427 9.1176 14.2222 8.45085C14.6017 7.7841 15.1441 7.22391 15.7991 6.82239C15.383 6.22985 14.8341 5.74221 14.196 5.39821C13.5579 5.0542 12.8482 4.86331 12.1231 4.84069C10.5765 4.6788 9.07714 5.76357 8.289 5.76357C7.48562 5.76357 6.27218 4.85676 4.96549 4.88357C4.12029 4.9108 3.29658 5.15589 2.57461 5.59496C1.85264 6.03403 1.25704 6.6521 0.845836 7.38896C-0.935375 10.4643 0.393251 14.984 2.09953 17.4699C2.95323 18.6871 3.95094 20.0468 5.25645 19.9986C6.53397 19.9458 7.01109 19.1863 8.55315 19.1863C10.0809 19.1863 10.5285 19.9986 11.8605 19.968C13.2314 19.9458 14.0951 18.7453 14.9188 17.5165C15.5322 16.6492 16.0042 15.6906 16.3173 14.6762C15.5209 14.3403 14.8413 13.7781 14.3631 13.0596C13.885 12.3411 13.6296 11.4981 13.6286 10.6358Z"
      fill="white"
    />
    <path
      d="M11.1115 3.20594C11.8589 2.31119 12.2271 1.16113 12.138 0C10.9961 0.119599 9.94126 0.66383 9.18373 1.52425C8.81335 1.94459 8.52968 2.43361 8.34893 2.96334C8.16819 3.49307 8.09391 4.05313 8.13035 4.6115C8.70151 4.61736 9.26656 4.49391 9.78294 4.25045C10.2993 4.00698 10.7536 3.64985 11.1115 3.20594V3.20594Z"
      fill="white"
    />
  </svg>
);

export default AppleIcon;
